/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// local imports
import { ApiResponse } from '@models/api-response.model';
import { Truck } from '@core/models/truck.model';
import { ApiService } from 'app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class CarriersService {
  constructor(private apiService: ApiService, private http: HttpClient) {}

  addTruck(companyId: string, params: any): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(`${this.apiService.companies}/${companyId}/equipment/trucks`, params)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  removeTruck(companyId: string, truckId: string): Observable<ApiResponse> {
    return this.http
      .delete<ApiResponse>(`${this.apiService.companies}/${companyId}/equipment/trucks/${truckId}`)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  updateTruck(companyId: string, truckId: string, truck: Truck): Observable<ApiResponse> {
    return this.http
      .put<ApiResponse>(`${this.apiService.companies}/${companyId}/equipment/trucks/${truckId}`, truck)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  addDocument(companyId: string, docType: string, docs: any): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(`${this.apiService.companies}/${companyId}/documents?type=${docType}`, docs)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  removeDocument(companyId: string, docType: string): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(`${this.apiService.companies}/${companyId}/documents?type=${docType}`, {
        docs: [],
      })
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  // Send generic email
  sendGenericEmail(params: { emails: string[]; subject: string; message: string }): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(`${this.apiService.utils}/generic-email`, params)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }
}
